<template>
  <div data-name="PositionCardMenu" data-node-id="15235:186917">
    <HorizontalMenu
      :items="menuItems"
      size="small"
      :bottomLine="false"
      :fixedTabs="false"
      :value="selectedTab"
      @onChange="handleTabChange"
    />
  </div>
</template>

<script setup>
import { ref, defineEmits, computed, watch } from 'vue';
import HorizontalMenu from '@components/HorizontalMenu/HorizontalMenu.vue';

const props = defineProps({
  value: {
    type: Number,
    default: 0
  },
  attachedRolesCount: {
    type: Number,
    default: 0
  },
  assignmentsCount: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['tab-change']);

const selectedTab = ref(props.value);

watch(() => props.value, (newVal) => {
  selectedTab.value = newVal;
});

const menuItems = computed(() => [
  { title: 'Purpose', count: null },
  { title: 'Attached Roles', count: props.attachedRolesCount ?? 0 },
  { title: 'Assignments', count: props.assignmentsCount ?? 0 }
]);

function handleTabChange(value) {
  selectedTab.value = value;
  emit('tab-change', value);
}
</script>
